import { COMPANY } from "@/data/content";
import { Link } from "react-router-dom";

const FINALITA = [
  { t: "Stipula ed esecuzione del contratto assicurativo", b: "Esecuzione di un contratto", c: "Per tutta la durata del contratto e fino a 10 anni dalla conclusione" },
  { t: "Adempimento obblighi legali (es. normativa antiriciclaggio)", b: "Obbligo di legge", c: "Come previsto dalle normative vigenti" },
  { t: "Accertamento, esercizio o difesa di diritti in sede giudiziaria", b: "Interesse legittimo", c: "Per la durata del contenzioso" },
  { t: "Recupero crediti stragiudiziale", b: "Interesse legittimo", c: "Per il tempo necessario al recupero" },
  { t: "Invio di comunicazioni promozionali e marketing diretto", b: "Consenso dell'utente", c: "Fino a 24 mesi" },
  { t: "Profilazione per personalizzazione offerte e analisi statistiche", b: "Consenso dell'utente", c: "Fino a 12 mesi" },
];

export default function Privacy() {
  return (
    <div data-testid="page-privacy" className="pt-28 pb-32">
      <section className="container-x py-12 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <span className="overline">GDPR · Reg. (UE) 2016/679</span>
        </div>
        <div className="md:col-span-8">
          <h1 className="font-display text-5xl sm:text-6xl leading-[1.05] tracking-tight">
            Informativa <span className="italic text-primary">Privacy</span>
          </h1>
          <p className="mt-4 text-primary font-medium">Termini e condizioni</p>
        </div>
      </section>

      <section className="container-x grid md:grid-cols-12 gap-16">
        <div className="md:col-span-8 md:col-start-3 space-y-12 text-muted-foreground leading-relaxed">
          <p className="text-lg">
            {COMPANY.legalName}, con sede legale in {COMPANY.address}, in qualità di Titolare del trattamento dei dati
            personali, fornisce la presente informativa ai sensi dell'art. 13 del Regolamento (UE) 2016/679 (GDPR).
          </p>

          <div>
            <h2 className="font-display text-2xl sm:text-3xl text-foreground">1. Titolare del Trattamento</h2>
            <div className="mt-4 border border-foreground/10 p-6">
              <p className="font-display text-xl text-foreground">{COMPANY.legalName}</p>
              <p className="mt-2 text-sm">Indirizzo: {COMPANY.address}</p>
              <p className="text-sm">Email: <a href={`mailto:${COMPANY.email}`} className="text-primary underline-link">{COMPANY.email}</a></p>
            </div>
          </div>

          <div>
            <h2 className="font-display text-2xl sm:text-3xl text-foreground">2. Tipologia di dati trattati</h2>
            <p className="mt-4">I dati personali raccolti possono includere:</p>
            <ul className="mt-3 space-y-2 pl-6 list-disc">
              <li>Dati anagrafici (nome, cognome, data di nascita, codice fiscale)</li>
              <li>Dati di contatto (email, telefono, indirizzo)</li>
              <li>Dati necessari per la stipula e gestione dei contratti assicurativi</li>
              <li>Informazioni di pagamento (IBAN, dati bancari)</li>
            </ul>
          </div>

          <div>
            <h2 className="font-display text-2xl sm:text-3xl text-foreground">3. Finalità e Base giuridica del trattamento</h2>
            <p className="mt-4">I dati saranno trattati per le seguenti finalità:</p>
            <ul className="mt-6 space-y-5 border-t border-foreground/10">
              {FINALITA.map((f) => (
                <li key={f.t} className="border-b border-foreground/10 pb-5">
                  <p className="text-foreground font-medium">{f.t}</p>
                  <p className="mt-2 text-sm"><span className="text-foreground/70">Base giuridica:</span> {f.b}</p>
                  <p className="text-sm"><span className="text-foreground/70">Periodo di conservazione:</span> {f.c}</p>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="font-display text-2xl sm:text-3xl text-foreground">4. Modalità del trattamento</h2>
            <p className="mt-4">
              Il trattamento dei dati avviene con strumenti elettronici e cartacei, nel rispetto delle misure di sicurezza
              previste dalla normativa.
            </p>
          </div>

          <div>
            <h2 className="font-display text-2xl sm:text-3xl text-foreground">5. Destinatari dei dati personali</h2>
            <p className="mt-4">I dati potranno essere comunicati a:</p>
            <ul className="mt-3 space-y-2 pl-6 list-disc">
              <li>Autorità di vigilanza e controllo</li>
              <li>Compagnie di assicurazione e intermediari</li>
              <li>Studi legali e periti</li>
              <li>Società di servizi IT e manutenzione del sito web</li>
              <li>Fornitori di servizi di marketing (se hai dato il consenso)</li>
            </ul>
          </div>

          <div>
            <h2 className="font-display text-2xl sm:text-3xl text-foreground">6. Diritti dell'Interessato</h2>
            <p className="mt-4">In qualsiasi momento puoi esercitare i seguenti diritti:</p>
            <ul className="mt-3 space-y-2 pl-6 list-disc">
              <li>Accesso ai tuoi dati e richiesta di copia</li>
              <li>Rettifica di dati inesatti</li>
              <li>Cancellazione dei dati nei casi previsti dal GDPR</li>
              <li>Limitazione del trattamento</li>
              <li>Opposizione al trattamento per finalità di marketing</li>
              <li>Portabilità dei dati a un altro titolare</li>
            </ul>
            <p className="mt-4">
              Per esercitare i tuoi diritti, scrivi a:{" "}
              <a href={`mailto:${COMPANY.email}`} className="text-primary underline-link" data-testid="privacy-contact-email">{COMPANY.email}</a>
            </p>
          </div>

          <div>
            <h2 className="font-display text-2xl sm:text-3xl text-foreground">7. Cookie e Tracciamento online</h2>
            <p className="mt-4">
              Per informazioni sui cookie utilizzati, consulta la nostra{" "}
              <Link to="/cookie" className="text-primary underline-link" data-testid="privacy-to-cookie">Informativa sui Cookie</Link>.
            </p>
          </div>

          <div>
            <h2 className="font-display text-2xl sm:text-3xl text-foreground">8. Modifiche alla presente informativa</h2>
            <p className="mt-4">
              Questa informativa può essere aggiornata. Ti invitiamo a consultarla periodicamente.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
